import Vue from 'vue';
import Component from 'vue-class-component';
import {DownloadHelper} from '../../../../helpers/download';
import {Watch} from 'vue-property-decorator';
import {DataManager, Visualisation, Toolbar, Chart, FilterBar, CustomDynamicView} from 'wc-visualisation';
import {Table, Icon, FieldType, Popover, pivotData} from 'wc-lib';
import {addSeconds, addYears, format} from 'date-fns';

require('wc-lib/icons/electricity.svg');
require('wc-lib/icons/table.svg');
require('wc-lib/icons/download.svg');
require('wc-lib/icons/graph.svg');
require('wc-lib/icons/infocircle.svg');

@Component({
  template: require('./monthly-unserved-energy.html'),
  name: 'monthly-unserved-energy',
  components: {
    'vis-visualisation': Visualisation,
    'vis-toolbar': Toolbar,
    'wc-icon': Icon,
    'vis-table': Table,
    'vis-chart': Chart,
    'vis-filter-bar': FilterBar,
    'wc-popover': Popover
  }
})
export class MonthlyUnservedEnergy extends Vue {
  data: Array<any> = [];
  dynamicView: CustomDynamicView<any>;
  chartVisible = true;
  tableVisible = false;  
  availableRegions: string[] = [];
  selectedRegion: string = '';
  availableYears: string [] = [];
  selectedYear: string = '';
  infoText: string = 'This figure shows the weighted unserved energy outcomes for each region. The figure shows for each month, the weighted unserved energy observed across all simulations.';
  runDateTime: string = "";
  runNo: string = "";
  id: string;
  columns: Array<any> = [    
    { title: 'MONTH', field: 'MONTH' },
    { title: 'WEIGHTED Unserved Energy', field: 'WEIGHTEDMONTHLYUSE' } ,
    { title: 'Region', field: 'REGIONID' }
  ];

  get chartButtonType(): string {
    return this.chartVisible ? 'primary' : 'ghost';
  }

  get tableButtonType(): string {
    return this.tableVisible ? 'primary' : 'ghost';
  }


    chartConfig: any = {
    type: 'serial',
    theme: 'simpleblue',
    valueAxes: [{
        id: 'v1',
        position: 'left',
        title: 'Expected Unserved Energy (MWh)',
        labelsEnabled: true,
        minimum: 0
      }],
    graphs: [          
       { valueAxis: 'v1', type:'column',  lineThickness:1,  columnWidth: 0.2, fillAlphas: 0.8, lineAlpha: 0.2, fillColors: ['#3363FF'],valueField: 'WEIGHTEDMONTHLYUSE' } 
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false
    },
    categoryAxis: {
      parseDates: false,
      color: '#6F7072',
      gridAlpha: 0.5,
      autoGridCount: true
    },    
    categoryField: 'MONTH'
  }

  applyFilter() {
    this.dynamicView.removeFilters();
    this.dynamicView.applyFind({'REGIONID': this.selectedRegion, 'YEAR': this.selectedYear });
    this.data = this.dynamicView.data();
  }


  async created() {
    this.id = await DataManager.addEndPoint('../../api/report/MTPASA_CHART_2c', undefined, undefined, 'MTPASA_CHART_2c', undefined, 'yyyy-MM-ddTHH:mm:ss', ['RUN_DATETIME', 'PERIOD_ENDING']);
    this.dynamicView = DataManager.getDynamicView(this.id, 'monthly-unserved-energy');
    this.dynamicView.removeFilters();
    let allData = this.dynamicView.data();
    this.runDateTime = format(allData[0].RUN_DATETIME, 'yyyy-MM-dd HH:mm:ss');
    this.runNo = allData[0].RUN_NO;
    let i = 0;
    let currYear = '';
    for(let idx = 0; idx < allData.length; idx++) {
      let x = allData[idx];       
      if(this.availableRegions.indexOf(x.REGIONID) === -1) {
        this.availableRegions.push(x.REGIONID);
      }
      currYear = format(addSeconds(x.PERIOD_ENDING, -1), 'yyyy');
      if(this.availableYears.indexOf(currYear) === -1) {
        this.availableYears.push(currYear);
      }
      x.MONTH = format(addSeconds(x.PERIOD_ENDING, -1), 'MMM-yy');
      x.YEAR = currYear;
      this.selectedRegion = x.REGIONID;      
      this.selectedYear = currYear;     
    }

    this.applyFilter();
  }

  @Watch('selectedRegion')
  onSelectedRegionChange(newValue: string, oldValue: string) {
    this.applyFilter();
  }



  @Watch('selectedYear')
  onSelectedYearChange(newValue: string, oldValue: string) {
    this.applyFilter();
  }

  chartClick() {
    this.chartVisible = true;
    this.tableVisible = false;
  }

  tableClick() {
    this.tableVisible = true;
    this.chartVisible = false;
  }

  downloadClick() {
    DownloadHelper.download('MTPASA_CHART_2c', this.data, this.columns);
  }
}



// WEBPACK FOOTER //
// src/views/electricity/nem/mtpasa/monthly-unserved-energy.ts